// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"a3780e7d","418":"d15360c9","480":"a9c0d842"}[chunkId] + ".js";
};